import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom'; 
import './App.css';
import { useTranslation } from 'react-i18next';
import Navbar from './Navbar'; 
import Carousel from './Carousel'; 
import FeaturedProducts from './FeaturedProducts'; 
import ProductsPage from './Product'; 
import ProductDetails from './ProductDetails'; 
import Signup from './Signup';
import Login from './Login';
import Cart from './Cart'; 
import Footer from './Footer'; 
import "./i18n";


function App() {
  const { i18n } = useTranslation();
  const [dropdownVisible, setDropdownVisible] = useState(false);

  // Cart state
  const [cart, setCart] = useState([]);

  // Function to add an item to the cart
  const addToCart = (product) => {
    setCart((prevCart) => [...prevCart, product]);
    alert(`${product.name} 已加入購物車!`);
  };

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    setDropdownVisible(false);
  };

  return (
    <Router>
      <div className="App">
        <Navbar
          cartLength={cart.length}
          changeLanguage={(lang) => i18n.changeLanguage(lang)}
        />

        {/* Define Routes */}
        <Routes>
          <Route
            path="/"
            element={
              <>
                {/* Body Sections */}
                <Carousel /> {/* Use your Carousel component here */}
                <FeaturedProducts /> {/* Use the new FeaturedProducts component */}
                <div className="pay-info">
                  <img src="/Homepage/pay_information.png" alt="Pay Info" className="pay-info-image" />
                </div>
              </>
            }
          />
          <Route path="/" element={<Carousel />} />
          <Route path="/products" element={<ProductsPage addToCart={addToCart} />} />
          <Route path="/product/:id" element={<ProductDetails addToCart={addToCart} />} />
          <Route path="/cart" element={<Cart cart={cart} setCart={setCart} />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
        </Routes>
        {/* Footer */}
        <Footer />
      </div>
    </Router>
  );
}

export default App;